<template>
  <PullRefresh
    v-model="isLoading"
    success-text="刷新成功"
    @refresh="onRefresh"
    :disabled="dialogVisible"
  >
    <!-- 未开始-0 或 已结束-2 或 已下架  -->
    <div
      v-if="
        activityInfo.activeStatus === 0 ||
        activityInfo.activeStatus === 2 ||
        errCode == 90130
      "
      :class="$style.pageNative"
    >
      <img
        v-if="activityInfo.activeStatus === 0"
        :src="`${CDN_URL_1}/box_subscribe/unStart.png`"
      />
      <div
        v-if="activityInfo.activeStatus === 0 && errCode != 90130"
        :class="$style.nativeStatus"
      >
        活动将于{{ activityInfo.startTime }}开始
      </div>
      <img
        v-if="activityInfo.activeStatus === 2"
        :src="`${CDN_URL_1}/box_subscribe/end.png`"
      />
      <div v-if="activityInfo.activeStatus === 2" :class="$style.nativeStatus">
        活动已结束
      </div>
      <div v-if="errCode == 90130" :class="$style.nativeStatus">活动已下架</div>
    </div>

    <!-- 进行中-1  -->
    <div
      v-if="activityInfo.activeStatus === 1"
      :class="`${$style.pageContent}`"
    >
      <div :class="$style.activityInfo">
        <div :class="$style.gameImage">
          <img :src="activityInfo.banner" />
        </div>
        <div :class="$style.activityPlaces">
          <div v-if="activityInfo.games.length > 0">
            <div
              v-for="item in activityInfo.games.slice(0, 5)"
              :key="item.gameId"
              :style="{ display: 'inline-block', position: 'relative' }"
            >
              <img
                :src="item.logo"
                :class="`${$style.placeIcon} ${
                  item.gameId == selectPlaceId ? $style.activePlace : ''
                }`"
                @click="onHandlePlace(item.gameId)"
              />
              <div v-if="item.play" :class="$style.isPlay">最近在玩</div>
            </div>
          </div>
          <div
            v-if="activityInfo.games.length > 5"
            :class="$style.morePlace"
            @click="openDialog(1)"
          >
            <img :src="`${CDN_URL_1}/box_payAmount/more.png`" />
            <p :class="$style.moreText">更多游戏</p>
          </div>
        </div>
      </div>
      <div :class="$style.gameWrapper" @touchmove.stop @touchend.stop>
        <div :class="$style.gameInfo">
          <div :class="$style.title">
            {{ curPlaceInfo.appName }}
            <p :class="$style.tag">{{ curPlaceInfo.gameTag }}</p>
          </div>
          <div
            :class="$style.button"
            @click="onSkipDetail(curPlaceInfo.gameId)"
          >
            下载/查看游戏
          </div>
        </div>
        <div :class="$style.dayInfo">
          <div
            v-for="(item, index) in day.slice(0, activityInfo.totalDays)"
            :key="index"
            @click="onSelectDay(index + 1)"
            :class="`${$style.dayItem} ${
              index + 1 == activityInfo.inDays
                ? $style.curDay
                : index + 1 == curSelect
                ? $style.curSelect
                : ''
            }`"
          >
            <div :class="$style.day">
              <div :class="$style.span">第</div>
              <div>{{ item.text }}</div>
              <div :class="$style.span">天</div>
            </div>
            <p :class="$style.desc">礼包</p>
            <img
              v-if="index + 1 == curSelect"
              :class="$style.select"
              :src="`${CDN_URL_1}/box_doubleWelfare/select.png`"
            />
          </div>
        </div>
      </div>

      <div v-if="giftList.length > 0" :class="$style.giftWrapper" @touchmove.stop @touchend.stop >
        <div :class="$style.title">每日充值福利</div>
        <div :class="$style.giftList">
          <div
            v-for="item in giftList.slice(1)"
            :key="item.giftId"
            :class="$style.giftItem"
          >
            <img :class="$style.icon" :src="item.giftIcon" />
            <div :class="$style.info">
              <h3 :class="$style.title">{{ item.giftName }}</h3>
              <p :class="$style.content">{{ item.giftDesc }}</p>
            </div>
            <div>
              <div
                :class="`${$style.giftBtn} ${
                  item.giftStatus ? `${$style.disableBtn}` : ''
                }`"
                @click="onReceiveGift({ ...item })"
              >
                {{ drawStatusText(item) }}
              </div>
              <p :class="$style.money">充值{{ item.amount }}可领取</p>
            </div>
          </div>
        </div>
        <div :class="$style.title">每日登录福利</div>
        <div
          v-for="item in giftList.slice(0, 1)"
          :key="item.giftId"
          :class="$style.giftItem"
        >
          <img :class="$style.icon" :src="item.giftIcon" />
          <div :class="$style.info">
            <h3 :class="$style.title">{{ item.giftName }}</h3>
            <p :class="$style.content">{{ item.giftDesc }}</p>
          </div>
          <div>
            <div
              :class="`${$style.giftBtn} ${
                item.giftStatus ? `${$style.disableBtn}` : ''
              }`"
              @click="onReceiveGift({ ...item })"
            >
              {{ drawStatusText(item) }}
            </div>
            <p :class="$style.money">登录盒子可领取</p>
          </div>
        </div>
      </div>

      <!-- 弹窗 -->
      <ActivityDialog
        :title="dialogTitle"
        :visible="dialogVisible"
        :hideCancel="true"
        :hideSure="dialogType == 1"
        :sureText="sureText"
        @click-sure="onSureDialog"
        @click-cancel="dialogVisible = false"
        :herderStyle="{ background: '#ffb503' }"
        :dialogStyle="{ top: dialogType == 1 ? '16%' : '32%' }"
      >
        <template v-slot:main>
          <!-- 更多游戏弹窗 -->
          <div v-if="dialogType == 1" :class="$style.dialog1">
            <h2 :class="$style.dialogTitle">请选择</h2>
            <div :class="$style.dialogPlace">
              <div
                v-for="item in activityInfo.games"
                :key="item.gameId"
                :class="$style.item"
                @click="onHandlePlace(item.gameId)"
              >
                <img :src="item.logo" :class="$style.icon" />
                <div :class="$style.name">{{ item.appName }}</div>
                <div
                  v-if="item.play"
                  :class="$style.isPlay"
                  :style="{ top: '-12px' }"
                >
                  最近在玩
                </div>
              </div>
            </div>
          </div>
          <!-- 不满足活动条件 -->
          <div v-if="dialogType == 2" :class="$style.dialog2">
            <p :style="{ textAlign: 'center' }">
              当天在该游戏内充值金额达到{{
                curGiftInfo.amount
              }}元即可领取礼包
            </p>
            <div :class="$style.progress">
              <p :class="$style.text">当前进度</p>
              <p
                :class="$style.percentage"
                :style="{ width: percentage + '%' }"
              ></p>
              <p
                v-if="percentage < 100"
                :class="$style.amount"
                :style="{ left: (percentage == 0 ? 3 : percentage - 1) + '%' }"
              >
                {{ amount }}
              </p>
              <p :class="$style.typeValue">{{ curGiftInfo.amount }}</p>
            </div>
          </div>
          <!-- 领取成功 -->
          <div v-if="dialogType == 3" :class="$style.dialog3">
            <p :style="{ textAlign: 'center', marginBottom: '10px' }">
              礼包码已存放在
            </p>
            <p :style="{ textAlign: 'center', width: '100%' }">
              <span>【我的】</span>-<span>【我的礼包】</span>-<span
                >【活动礼包】</span
              >
            </p>
          </div>
          <!-- 礼包码生成错误 -->
          <div v-if="dialogType == 4" :class="$style.dialog4">
            <p :style="{ textAlign: 'center' }">
              兑换码生成错误，请联系客服领取备用码
            </p>
          </div>
        </template>
      </ActivityDialog>
    </div>
  </PullRefresh>
</template>

<script>
import { inithandler } from "@/bridge/jsBridge";
import { CDN_URL_1, CDN_URL } from "@/config";
import {
  setPageTitle,
  getUserInfo,
  toLogin,
  signInEventTrack,
  jumpToNative,
  clickRightTxt,
  setRightTxtColor,
  setRightTxt,
} from "@/bridge/AppJsBridge";
import { PullRefresh } from "vant";
import ActivityDialog from "@/components/btBox/ActivityDialog";
import { getCookie, pageLoseTips } from "@/libs/utils";
import {
  getDoubleWelfarePlaceApi,
  getDoubleWelfareApi,
  receiveDoubleWelfareApi,
} from "@/apis/wxActivity";
import { burnPoint } from "@/apis/heziShare";
import { queue } from "../../libs/queue.request";

export default {
  name: "",
  components: {
    PullRefresh,
    ActivityDialog,
  },
  data() {
    return {
      CDN_URL_1: CDN_URL_1,
      CDN_URL: CDN_URL,
      pageTitle: "",
      activityId: "",
      userInfo: "",
      isLoading: false,
      cookie: null,
      activityInfo: {
        activeStatus: 1,
        startTime: "",
        banner: "",
        games: [],
      },
      errCode: "",
      selectPlaceId: "",
      curPlaceInfo: {
        logo: "",
        appName: "",
        gameTag: "",
        gameId: "",
      },
      giftList: [],
      dialogVisible: false,
      dialogType: 1, // 1-更多游戏 2-不满足领取条件 3-领取成功 4-礼包码生成错误
      dialogTitle: "更多游戏",
      sureText: "",
      percentage: 1,
      amount: 0,
      curGiftInfo: {
        amount: 0,
        giftId: 0,
      },
      reqQueue: queue(),
      noticeScrollLocation: 0,

      // ===============
      day: [{ text: 1 }, { text: 2 }, { text: 3 }, { text: 4 }, { text: 5 }],
      curSelect: 0,
    };
  },
  computed: {
    drawStatusText: function () {
      return function ({ giftStatus }) {
        let text = "领取";
        let day = this.curSelect;
        if (giftStatus == 1) {
          text = "已领取";
        }
        if (giftStatus == 9) {
          text = `第${day}天可领`;
        }
        return text;
      };
    },
  },

  created() {
    // 页面初始化
    inithandler();
    this.reqQueue.create();
    this.initPageData();
    try {
      signInEventTrack((data) => {
        this.cookie = JSON.parse(data);
      });
    } catch (error) {
      // 错误处理
    }
    setInterval(() => {
      // if (this.noticeScrollLocation < 100) {
      this.noticeScrollLocation = this.noticeScrollLocation - 0.4;
      // }
      if (this.noticeScrollLocation < -53) {
        this.noticeScrollLocation = 0;
      }
    }, 100);
  },
  activated() {
    setRightTxt("活动规则");
  },
  watch: {
    cookie(value, oldValue) {
      if (!oldValue && value && !getCookie()) {
        this.reqQueue.run(value);
      }
    },
  },
  methods: {
    // 下拉刷新
    async onRefresh() {
      await this.initPageData();
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    // 数据上报
    eventTrack(data) {
      // this.$toast(data.event);
      if (!this.cookie) {
        console.log("数据上报异常", data.event, "转为补充数据上报");
        this.reqQueue.add(burnPoint, data);
        return;
      }
      console.log("正常数据上报", data.event);
      burnPoint({
        ...this.cookie,
        ...data,
      }).catch((err) => console.log(err));
    },

    // 获取缓存等携带的用户信息数据
    async initPageData() {
      this.setHeaderContent();
      const pageCookie = getCookie();
      if (pageCookie) {
        for (const key in pageCookie) {
          if (
            Object.hasOwnProperty.call(pageCookie, key) &&
            pageCookie[key] === "null"
          ) {
            delete pageCookie[key];
          }
        }
        this.cookie = pageCookie;
      }
      // 获取token
      this.getAppToken();
    },
    // 获取登录态
    getAppToken() {
      if (getCookie("token")) {
        localStorage.setItem("token", getCookie("token"));
        this.getActivityMainConfig();
      } else {
        getUserInfo((userInfo) => {
          let Info = JSON.parse(userInfo);
          if (Info.token) {
            localStorage.setItem("token", Info.token);
          }
          this.getActivityMainConfig();
        });
      }
    },

    // 获取活动主配置
    getActivityMainConfig() {
      getDoubleWelfarePlaceApi()
        .then((res) => {
          const { data } = res;
          this.pageTitle = data.actName;
          setPageTitle(data.actName);
          this.activityInfo = data;
          this.activityId = data.actId;
          this.curSelect = data.inDays;
          if (this.selectPlaceId) {
            this.getWxPayAmountActivityGifts(this.selectPlaceId, data.inDays);
          }
          if (data.games.length > 0 && !this.selectPlaceId) {
            this.selectPlaceId = data.games[0].gameId;
            this.getWxPayAmountActivityGifts(data.games[0].gameId, data.inDays);
            this.curPlaceInfo = data.games[0];
          }
          this.eventTrack({
            event: "double_welfare_page",
            event_field: JSON.stringify({
              act_id: this.activityId,
              act_name: data.actName,
            }),
          });
        })
        .catch((err) => {
          const { code, response } = err;
          if (code) {
            this.errCode = code;
          }
          if (response) {
            const { data } = response;
            if (data && data.code === 401) {
              toLogin("/loginKey/LoginByKeyPhoneActivity");
            }
          }
        });
    },

    // 点击游戏会场
    onHandlePlace(gameId) {
      this.selectPlaceId = gameId;
      if (this.activityInfo.games.length > 0) {
        let placeInfoItem = {};
        let placeInfoItemIndex = 0;
        this.activityInfo.games.map((item, index) => {
          if (item.gameId == gameId) {
            placeInfoItemIndex = index;
            placeInfoItem = item;
            this.curPlaceInfo = item;
          }
        });
        const arr = this.activityInfo.games.filter(
          (ele, index) => index != placeInfoItemIndex
        );
        this.activityInfo = {
          ...this.activityInfo,
          games: [placeInfoItem, ...arr],
        };
      }
      this.dialogVisible = false;
      this.getWxPayAmountActivityGifts(gameId, this.activityInfo.inDays);
      this.eventTrack({
        event: "double_welfare_game_icon",
        event_field: JSON.stringify({
          act_id: this.activityId,
          act_name: this.pageTitle,
        }),
        appName: this.curPlaceInfo.appName,
        appkey: this.curPlaceInfo.gameId,
      });
    },

    // 获取游戏会场礼包信息
    getWxPayAmountActivityGifts(gameId, inDays, cb) {
      if (!gameId) {
        this.$toast('网络异常，请退出页面重试')
        return
      }
      let params = {
        inDays,
        gameId,
      };
      getDoubleWelfareApi(params)
        .then((res) => {
          const { data } = res;
          if (data) {
            this.giftList = data;
          }
          cb && cb();
        })
        .catch((err) => {
          console.log("err:", err);
        });
    },

    // 领取礼包操作
    onReceiveGift(data) {
      const { giftStatus, giftId, giftName, amount } = data;
      this.curGiftInfo = data;
      if (giftStatus == 1) {
        this.openDialog(3, true);
        // 已领取
        return;
      }
      if (giftStatus == 9) {
        // 不可领取
        return;
      }
      receiveDoubleWelfareApi({
        giftId,
        inDays: this.activityInfo.inDays,
        gameId: this.selectPlaceId,
      })
        .then((res) => {
          const { data, code } = res;
          this.amount = data.amount;

          if (!data.hasComplete && !data.hasReceive) {
            this.percentage = Math.round(
              100 * (data.amount / data.targetAmount)
            );
            this.openDialog(2);
          }
          if (data.hasComplete && data.hasReceive) {
            this.openDialog(3);
          }
          if (data.hasComplete && !data.hasReceive) {
            this.openDialog(4);
          }
          this.getWxPayAmountActivityGifts(
            this.selectPlaceId,
            this.activityInfo.inDays
          );
          this.eventTrack({
            event: "double_welfare_get_gift",
            event_field: JSON.stringify({
              act_id: this.activityId,
              act_name: this.pageTitle,
              gift_id: giftId,
              gift_name: giftName,
              amount: data.amount,
              target: data.targetAmount,
            }),
            appName: this.curPlaceInfo.appName,
            appkey: this.curPlaceInfo.gameId,
          });
        })
        .catch((error) => {});
    },

    // 打开弹窗
    openDialog(type, isReceived = false) {
      this.dialogVisible = true;
      this.dialogType = type;
      if (type == 1) {
        this.dialogTitle = "更多游戏";
        this.eventTrack({
          event: "double_welfare_more_game",
          event_field: JSON.stringify({
            act_id: this.activityId,
            act_name: this.pageTitle,
          }),
        });
        return;
      }
      if (type == 2) {
        this.dialogTitle = "不满足领取条件";
        this.sureText = "去完成";
      }
      if (type == 3) {
        this.dialogTitle = "领取成功";
        this.sureText = "查看兑换码";
      }
      if (type == 4) {
        this.dialogTitle = "提示";
        this.sureText = "联系客服";
      }
      if (isReceived) {
        return;
      }
      this.eventTrack({
        event: "double_welfare_get_result_pop",
        event_field: JSON.stringify({
          act_id: this.activityId,
          act_name: this.pageTitle,
          gift_id: this.curGiftInfo.giftId,
          gift_name: this.curGiftInfo.giftName,
          amount: this.amount,
          target: this.curGiftInfo.amount,
          type: type - 1,
        }),
        appName: this.curPlaceInfo.appName,
        appkey: this.curPlaceInfo.gameId,
      });
    },

    // 确认弹窗
    onSureDialog() {
      if (this.dialogType == 2) {
        this.onSkipDetail(this.curPlaceInfo.gameId, true);
        this.eventTrack({
          event: "double_welfare_go_to_complete",
          event_field: JSON.stringify({
            act_id: this.activityId,
            act_name: this.pageTitle,
            gift_id: this.curGiftInfo.giftId,
            gift_name: this.curGiftInfo.giftName,
            amount: this.amount,
            target: this.curGiftInfo.amount,
          }),
          appName: this.curPlaceInfo.appName,
          appkey: this.curPlaceInfo.gameId,
        });
      }
      if (this.dialogType == 3) {
        this.onGoGiftDetail();
      }
      if (this.dialogType == 4) {
        this.onRelationServer();
      }
      this.dialogVisible = false;
    },

    // 游戏详情
    onSkipDetail(gameId, isPop = false) {
      if (!isPop) {
        this.eventTrack({
          event: "double_welfare_game_look",
          event_field: JSON.stringify({
            act_id: this.activityId,
            act_name: this.pageTitle,
          }),
          appName: this.curPlaceInfo.appName,
          appkey: this.curPlaceInfo.gameId,
        });
      }
      const data = {
        routePath: "/main/game/GameDetailActivity",
        fromPageType: 40,
        extraParams: gameId,
      };
      const dataStr = JSON.stringify(data);
      jumpToNative(dataStr);
    },

    // 礼包详情
    onGoGiftDetail() {
      if (this.curGiftInfo.giftStatus != 1) {
        this.eventTrack({
          event: "double_welfare_look_gift",
          event_field: JSON.stringify({
            act_id: this.activityId,
            act_name: this.pageTitle,
            gift_id: this.curGiftInfo.giftId,
            gift_name: this.curGiftInfo.giftName,
            amount: this.amount,
            target: this.curGiftInfo.amount,
          }),
          appName: this.curPlaceInfo.appName,
          appkey: this.curPlaceInfo.gameId,
        });
      }
      const data = {
        routePath: "/gift/MineGiftActivity",
        extraParams: 3,
      };
      const dataStr = JSON.stringify(data);
      jumpToNative(dataStr);
    },

    // 联系客服
    onRelationServer() {
      this.dialogVisible = false;
      this.$router.push({
        name: `box.customerService`,
      });
    },

    // 设置顶部内容
    setHeaderContent() {
      setRightTxtColor("#6879AD");
      setRightTxt("活动规则");
      clickRightTxt(() => {
        this.$router.push({
          name: `box.actPlaceRule`,
          params: {
            type: 20,
          },
        });
        this.eventTrack({
          event: "double_welfare_rule",
          event_field: JSON.stringify({
            act_id: this.activityId,
            act_name: this.pageTitle,
          }),
        });
      });
    },

    // 点击活动天数
    onSelectDay(value) {
      this.getWxPayAmountActivityGifts(this.selectPlaceId, value, () => {
        this.curSelect = value;
      });
    },
  },
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
<style lang="scss" module>
.pageContent {
  width: 100%;
  min-height: 100vh;
  max-width: 375px;
  margin: auto;
  overflow: auto;
  background-size: cover;
  background: #f6f6f6;
  position: relative;

  .dialog1 {
    max-height: 334px;
    overflow: auto;
    .dialogTitle {
      font-size: 20px;
      font-weight: 500;
      text-align: center;
      color: #ff5216;
    }
    .dialogPlace {
      display: flex;
      flex-wrap: wrap;
      margin-top: 18px;

      .item {
        width: 32%;
        margin-bottom: 14px;
        position: relative;
      }
      .icon {
        width: 58px;
        height: 58px;
      }
      .name {
        font-size: 15px;
        font-weight: 500;
        color: #333333;
        line-height: 24px;
      }
    }
  }

  .dialog2 {
    .progress {
      height: 8px;
      // background: #d43e41;
      border-radius: 8px;
      border: 1px solid #c73534;
      width: 80%;
      margin: 40px auto 50px;
      position: relative;
      .percentage {
        height: 7px;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        background: linear-gradient(#ff756a 0%, #ffb46b 100%);
        border-radius: 6px;
      }
      .text {
        font-size: 12px;
        color: #747474;
        font-weight: 500;
        position: absolute;
        top: -22px;
        width: auto;
        left: 0;
      }
      .amount {
        font-size: 12px;
        color: #c73534;
        font-weight: 500;
        position: absolute;
        top: 8px;
        width: auto;
        margin-left: -10px;
      }
      .amount::before {
        content: ".";
        position: absolute;
        top: -11px;
        left: 50%;
      }
      .typeValue {
        font-size: 12px;
        color: #c73534;
        font-weight: 500;
        position: absolute;
        right: -10px;
        top: 8px;
        width: auto;
      }
    }
    .progress::before {
      content: ".";
      color: #c73534;
      position: absolute;
      top: 0px;
      right: 0%;
    }
  }
  .activityInfo {
    margin: 7px 10px;
    .gameImage {
      // background: linear-gradient(180deg, #fde6d6 0%, #ffd6b5 100%);
      // padding: 3px 4px;
      display: inline-flex;
      > img {
        border-radius: 4px;
        width: 100%;
      }
    }
    .activityPlaces {
      width: 100%;
      height: 82px;
      background: #ffffff;
      border-radius: 5px;
      display: flex;
      align-items: flex-end;
      padding-bottom: 8px;
      position: relative;
      margin-top: 7px;
      .placeIcon {
        width: 45px;
        margin-left: 8px;
      }
      .activePlace {
        width: 60px !important;
      }
      .morePlace {
        width: 55px;
        margin-left: 5px;
        text-align: center;
        > img {
          width: 40px;
        }
        .moreText {
          font-weight: 500;
          text-align: center;
          color: #fc5f5e;
          font-size: 12px;
          margin-top: 2px;
        }
      }
    }
  }

  .gameWrapper {
    // width: 100%;
    // height: 500px;
    min-height: 136px;
    border-radius: 13.89px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin: 7px 10px;
    background: linear-gradient(181deg, #fff2e9 0%, #ffffff 99%);
    .gameInfo {
      display: flex;
      padding: 10px 13px 10px;
      align-items: center;
      justify-content: space-between;
      .title {
        font-size: 19px;
        font-weight: 700;
        text-align: left;
        color: #a1583e;
        display: flex;
      }
      .tag {
        height: 18px;
        line-height: 20px;
        padding: 0 9px;
        background: #ff6d6d;
        border-radius: 2px;
        text-align: center;
        font-size: 12px;
        font-weight: 400;
        color: #ffffff;
        margin-left: 3px;
      }
      .button {
        width: 118px;
        height: 30px;
        line-height: 30px;
        background: linear-gradient(
          44deg,
          rgba(255, 142, 27, 0.87) 0%,
          rgba(254, 184, 26, 0.87) 90%
        );
        border-radius: 13px;
        font-size: 15px;
        font-weight: 500;
        text-align: center;
        color: #ffffff;
        // margin-left: 88px;
      }
    }

    .curSelect {
      border: 1px solid #ff4031;
    }
    .dayInfo {
      display: flex;
      justify-content: space-evenly;
      align-items: flex-end;
      // width: 326px;
      margin: 0 10px;
      height: 78px;
      background: #ffe3d9;
      border-radius: 11px;
      padding-bottom: 6px;
      .dayItem {
        width: 54px;
        height: 52px;
        background: #ffffff;
        border-radius: 7px;
        color: #b1b1b1;
        position: relative;
        .day {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          font-size: 30px;
          height: 50px;
          font-weight: 700;
          text-align: center;
          position: relative;
          font-family: monospace;
          .span {
            font-size: 12px;
            transform: scale(0.8);
            font-weight: 400;
            margin-top: 2px;
          }
        }
        .desc {
          font-size: 12px;
          transform: scale(0.8);
          text-align: center;
          padding: 2px 0;
          margin-top: -12px;
        }
      }
      .curDay {
        width: 60px !important;
        height: 68px !important;
        background-image: url("//static.hzwxbz3.cn/Lianyun/font_end/wxhd/box_doubleWelfare/selectBg.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        // border-radius: 7px !important;
        background-color: transparent !important;
        .desc {
          display: none;
        }
        .day {
          color: #ffb000 !important;
          font-size: 38px !important;
          height: 68px !important;
          .span {
            color: #a1583e;
            // line-height: 40px;
          }
        }
      }
      .select {
        width: 15px;
        position: absolute;
        right: -1px;
        top: -1px;
      }
    }
  }
  .giftWrapper {
    margin: 7px 10px;
    min-height: 366px;
    background: linear-gradient(180deg, #fff2ea 0%, #fbfbfa 100%);
    border-radius: 13.89px;
    padding: 15px 12px;
    .title {
      height: 19px;
      font-size: 17.36px;
      font-weight: 700;
      text-align: left;
      color: #a1583e;
      margin-bottom: 12px;
    }
    .giftList {
      padding: 4px 0;
      overflow: scroll;
      max-height: 172px;
      margin-bottom: 6px;
    }
    .giftItem {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 5px;
      background: #ffffff;
      border-radius: 7px;
      width: 100%;
      padding: 8px 6px;
      .icon {
        width: 48px;
        height: 48px;
        margin-right: 3px;
      }
      .info {
        .title {
          width: 170px;
          line-height: 20px;
          font-size: 16px;
          font-weight: 700;
          text-align: left;
          color: #000000;
        }
        .content {
          width: 170px;
          line-height: 14px;
          font-size: 12px;
          font-weight: 500;
          text-align: left;
          color: #9f5829;
          margin-top: 4px;
        }
      }
      .giftBtn {
        width: 84px;
        height: 32px;
        background: #ff9916;
        border: 1px solid #ffb017;
        border-radius: 15px;
        font-size: 16px;
        font-weight: 600;
        text-align: left;
        color: #ffffff;
        line-height: 32px;
        text-align: center;
        margin: 0 auto;
      }
      .disableBtn {
        filter: grayscale(100%);
      }
      .money {
        width: 95px;
        line-height: 13px;
        font-size: 12px;
        font-weight: 400;
        text-align: center;
        color: #de482b;
        margin-top: 4px;
      }
    }
  }
  .isPlay {
    position: absolute;
    top: -18px;
    left: 42px;
    background-image: url("//static.hzwxbz3.cn/Lianyun/font_end/wxhd/box_payAmount/tips.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 30px;
    line-height: 24px;
    font-size: 12px;
    color: #fefefe;
    width: 64px;
    text-align: center;
    z-index: 1;
  }
}
.pageNative {
  position: relative;
  height: calc(100vh - 1px);
  > img {
    width: 100%;
    height: calc(100vh - 1px);
  }
  .nativeStatus {
    width: 375px;
    height: 39.24px;
    line-height: 39.24px;
    position: absolute;
    top: calc(50% - 39px);
    font-weight: 500;
    text-align: center;
    color: #ffffff;
    font-size: 18.75px;
    background: linear-gradient(
      to right,
      rgba(0, 0, 0, 0.1),
      rgba(0, 0, 0, 0.6),
      rgba(0, 0, 0, 0.1)
    );
    letter-spacing: 1px;
  }
}
</style>
